import { useContext, useEffect, useState } from "react";

import CreateCancelmicro from "../../../../components/forms/CreateCancelmicro";
import TabelProps from "../../../../components/tabel/props/TabelProps";
import DashboardContext from "../../../../Context";
import FormLeave from '../../leave/FormLeave'

export default function LevelWorker() {

    const { showformmicro, sideBardata } = useContext(DashboardContext)

    const [arryactions, setArryactions] = useState([]);

    useEffect(() => {
        if (sideBardata) {
            sideBardata.map(item => {
                item.controllers.filter(find => {
                    if (`/${find.controller}` === "/Leave") {
                      //console.log(find.actions);
                      setArryactions(find.actions);
                      return find;
                    }
                })
            })
        }
        return () => {

        };
    }, []);



    return (
        <>
            <CreateCancelmicro ismicro actions={arryactions} />
            {
                showformmicro ?
                    <FormLeave urlWebsilte='/Leave' />
                    :
                    arryactions.includes('Get') ? <TabelProps urldata='/Leave' arryactions={arryactions} accordionTable/> : "شما اجازه دسترسی به این بخش را ندارید :("
            }
        </>
    )
}
